import React from "react";
import { Tick } from '@sainsburys-tech/icons'

const TickIcon = () => <Tick className="cb-c-tick-icon" />;

export default TickIcon;
